import React, { useState, useEffect } from "react";
import proConnectLogo from "../../assets/images/proconnect-logo.png";
import proConnectImgTwo from "../../assets/images/proConnectImgTwo.jpg";
import proConnectImgThree from "../../assets/images/proConnectImgThreeNew.jpg";
import proConnectImgFour from "../../assets/images/proConnectImgFour.jpg";
import SocialEngagement from "../../assets/images/SocialEngagement.jpg";
import DigitalLearning from "../../assets/images/digitalLearning.jpg";
import PlacementImg from "../../assets/images/PlacementImg.jpg";
import EventImg from "../../assets/images/EventImg.jpg";
import InfoCard from "../CustomComponent/InfoCard.tsx";
import styles from "./studentWorld.module.scss";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";

interface PreconnectModule {
  imgSrc: string;
  title: string;
  subTitle: string;
}
const breadcrumb = [
  { title: "Home", link: "/" },
  { title: "Student World", link: "/students-world" },
  { title: "ProConnect", link: "" },
];

const infoCardsData = [
  {
    text: "1. Collaborative Learning:",
    subText:
      "Students can upload their projects in the platform and receive feedback from peers. They also gain recognition from the community for their works and talent.",
  },
  {
    text: "2.	Access to Resources:",
    subText:
      "A centralized platform providing easy access to academic materials. This ensures students receive required data at their fingertips. ",
  },
  {
    text: "3.	Career Opportunities:",
    subText:
      "Students can apply for jobs in relevant fields directly through the platform, with additional support of nominations from their centres. ",
  },
  {
    text: "4.	Access to Events:",
    subText:
      "Great opportunity for students to participate in events and network with peers and faculty. ",
  },
  {
    text: "5. Networking opportunities:",
    subText:
      "A platform for students to network with alumni, enhance their skills, and focus on achieving their career goals through interactions and guidance.",
  },
];
const preconnectModuleItem: PreconnectModule[] = [
  {
    imgSrc: SocialEngagement,
    title: "Social Engagement",
    subTitle:
      "Students can upload their projects to the platform. The projects upon faculty approval, appear in a community feed. This feature allows for peer interaction, feedback, and inspiration, cultivating a sense of community building and shared learning.  ",
  },
  {
    imgSrc: DigitalLearning,
    title: "Digital Learning",
    subTitle:
      "ProConnect is a centralized hub for all academic resources. It offers students easy access to program materials, attendance records, and program fee details. This feature ensures that learning is streamlined and all essential information is available in one place. ",
  },
  {
    imgSrc: PlacementImg,
    title: "Placement",
    subTitle:
      "ProConnect supports career growth by enabling students to apply for jobs. Aptech centres can nominate qualified candidates for specific job roles, enhancing career opportunities. This makes job application process effective and accessible. ",
  },
  {
    imgSrc: EventImg,
    title: "Events",
    subTitle:
      "There is a dedicated feature for students to engage in various academic, cultural, and professional events. This feature encourages skill-building and networking with peers within the community. ",
  },
];

const ProConnect: React.FC = () => {
  return (
    <div id="ProConnect" className={styles.proConnect}>
      <BreadCrumb menu={breadcrumb} />
      <ProConnectBanner />
      <div className="container">
        <ProConnectKeyModuleSection />
        <EmpoweringStudentSection />
      </div>
    </div>
  );
};

const ProConnectBanner = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1080);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1080);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="container-fluid mt-5">
      {!isMobile && (
        <div className="section">
          <div className={`${styles.ProConnectBanner} row g-0`}>
            <div className="col-3">
              <img
                src={proConnectLogo}
                alt="proConnectLogo"
                className={`${styles.proConnectBannerImg} img-fluid`}
              />
            </div>
            <div className="col-6 ">
              <p className="heading pt-4">
                ProConnect - Learn. Connect. Grow.
              </p>
              <p className="para">
                ProConnect is Aptech’s comprehensive, all-in-one platform
                designed to foster seamless collaboration, communication, and
                engagement across its ecosystem. The platform connects Aptech
                students, faculty, and business partners in a dynamic and
                interactive environment, empowering them to work together and
                drive success.
              </p>
            </div>

            <div
              className={`col-3 col-lg-3 col-md-3 d-flex justify-content-center align-items-start ${styles.proConnectSecondImgStyle}`}
            >
              <img
                src={proConnectImgTwo}
                alt="proConnectImgTwo"
                className="img-fluid"
              />
            </div>

            <div className="col-6 d-flex justify-content-center align-items-end">
              <img
                src={proConnectImgThree}
                alt="proConnectImgThree"
                className="img-fluid"
              />
            </div>

            <div
              className={`col-lg-6 col-md-6 d-flex justify-content-center align-items-end ${styles.proConnectImgFourthImgStyle}`}
            >
              <img
                src={proConnectImgFour}
                alt="proConnectImgFour"
                className="img-fluid"
              />
            </div>
          </div>
          {/* </div> */}
        </div>
      )}
      {isMobile && (
        <div className="section">
          <div className={`${styles.ProConnectBanner}`}>
            <div className="container">
              <div className={`row g-0`}>
                <div
                  className={`col-12 d-flex justify-content-end align-items-start ${styles.proConnectSecondImgStyle}`}
                >
                  <img
                    src={proConnectImgTwo}
                    alt="proConnectImgTwo"
                    className={`${styles.proConnectImgTwo} img-fluid`}
                  />
                </div>
                <div className="col-12">
                  <img
                    src={proConnectLogo}
                    alt="proConnectLogo"
                    className={`${styles.brandLogo} img-fluid`}
                  />
                </div>
                <div className="col-12 ">
                  <p className="heading pt-4">
                    ProConnect - All-in-One Platform by Aptech
                  </p>
                  <p className="para">
                    ProConnect is Aptech’s comprehensive, all-in-one platform
                    designed to foster seamless collaboration, communication,
                    and engagement across its ecosystem. The platform connects
                    Aptech students, faculty, and business partners in a dynamic
                    and interactive environment, empowering them to work
                    together and drive success.
                  </p>
                </div>
                <div className="col-7 d-flex justify-content-center align-items-end">
                  <img
                    src={proConnectImgThree}
                    alt="proConnectImgThree"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={`d-flex justify-content-end ${styles.fourthImgDivInMob}`}
          >
            <img
              src={proConnectImgFour}
              alt="proConnectImgFour"
              className={`img-fluid ${styles.fourthImgInMob}`}
            />
          </div>
        </div>
      )}
    </div>
  );
};
const ProConnectKeyModuleSection = () => {
  return (
    <div className={`${styles.proConnectKeyModuleSection} section`}>
      <div className="row mb-4 mb-md-5">
        <div className="col-12">
          <p className="heading text-center">
            The key modules of ProConnect are:
          </p>
        </div>
      </div>
      <div className="row">
        {preconnectModuleItem.map((item, index) => (
          <div
            className="col-lg-6 col-md-6 col-sm-12 mb-4 d-flex flex-column justify-content-start"
            key={index}
          >
            <p className="subHeading fw-bold text-uppercase mb-4">
              {item.title}
            </p>
            <img src={item.imgSrc} alt="preconnectModuleItem" className="" />
            <p className="para pt-3">{item.subTitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const EmpoweringStudentSection = () => {
  return (
    <div className={`${styles.empoweringStudentSection} section`}>
      <div className="row justify-content-center">
        <p className={`${styles.mainHeading} heading mb-4 `}>
          Empowering Students through ProConnect 
        </p>
        {infoCardsData.map((content, index) => (
          <div className="col-lg-6 col-md-6 col-sm-12" key={index}>
            <InfoCard
              text={content.text}
              height="90%"
              subText={content.subText}
              contentAlign="start"
              padding="2em 1em"
            />
          </div>
        ))}
      </div>
    </div>
  );
};


export default ProConnect;
